export default __webpack_public_path__ + "static/media/earface-new-crop.5a8f2405.jpg";